import { useState } from 'react';
import HeroSection from '@components/Products/FixedDeposits/HeroSection';
import { ProductWhyInvest } from '@components/Products/ProductWhyInvest';
import {
    fdApplicationProcess,
    fdFaqs,
    getFdKeyFeatures,
} from '@components/Products/FixedDeposits/utils/helper';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { fdRedirectTo } from '@components/Products/FixedDeposits/utils/utils';
import FixedDepositsCarousel from '@components/Products/FixedDeposits/Carousel';
import { ProductHowStructured } from '@components/Products/ProductHowStructured';
import Button from '@ui/atoms/design-system/Button';
import texts from '@components/Products/FixedDeposits/en.json';
import HowToPickRight from '@components/Products/FixedDeposits/HowToPickRight';
import Footer from '@molecules/Footer';
import FDInterestRateComparison from '@components/Products/FixedDeposits/ComparisonTable';
import FDCalculatorContainer from '@components/Products/FixedDeposits/FDCalculatorContainer';
import ProductFAQs from '@components/Products/productFAQs';
import DownloadAppQrCode from '@molecules/DownloadAppQrCode';
import { Image } from '@ui/atoms';
import { triggerOnPage } from '@helpers/ga-events-name-enum';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';

const FixedDeposits = ({
    fixedDepositBanks,
    fdCompareContent,
    fdInterestRate,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { width } = useWindowDimensions();
    const isMobile = width < 1024;
    const handleOnClick = () => {
        isMobile ? fdRedirectTo() : toggleModal();
        triggerCustomGaEvent(triggerOnPage.CLICKED_FD_BOOKED_NOW);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const onDownloadClick = () => {
        setIsModalOpen(false);
    };

    const fdKeyFeatures = getFdKeyFeatures(fdInterestRate);

    return (
        <>
            <div>
                <div className="relative flex-col items-center pt-16 min-h-[100svh]">
                    <HeroSection
                        fdInterestRate={fdInterestRate}
                        handleOnClick={handleOnClick}
                    />
                    <div className="max-w-screen-maxScreen mx-auto">
                        <div className="relative z-10">
                            <ProductWhyInvest
                                productWhyInvest={fdKeyFeatures}
                            />
                        </div>
                        <FixedDepositsCarousel
                            fixedDepositBanks={fixedDepositBanks}
                            handleOnClick={handleOnClick}
                        />
                        <FDCalculatorContainer handleOnClick={handleOnClick} />
                        <div className="pb-8 xl:pb-16 max-w-[1200px] mx-auto">
                            <ProductHowStructured
                                productHowStructured={fdApplicationProcess}
                            />
                            <div className="flex justify-center mt-8">
                                <Button
                                    onClick={handleOnClick}
                                    buttonText={texts?.bookFdNow}
                                    buttonSize="large"
                                />
                            </div>
                        </div>
                    </div>
                    <HowToPickRight />
                    <div className="relative max-w-screen-maxScreen mx-auto">
                        <div className='relative z-10'>
                            {' '}
                            <FDInterestRateComparison
                                fdCompareContent={fdCompareContent}
                            />
                            <ProductFAQs
                                selectedProduct={{ productFaqs: fdFaqs }}
                                isDesignSystemButton={true}
                                buttonType={'secondary'}
                            />
                        </div>
                        <div
                            style={{ pointerEvents: 'none' }}
                            className={`absolute hidden xl:block right-0 bottom-0 z-0`}
                        >
                            <Image src={'/images/products/sdis-bg-right.svg'} />
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
            {isModalOpen ? (
                <DownloadAppQrCode
                    show={isModalOpen}
                    onClose={() => onDownloadClick()}
                    hideTitle={true}
                />
            ) : null}
        </>
    );
};

export default FixedDeposits;
